import http from "./http";

const unwrap = (response) => response?.data?.data ?? response?.data;

export async function getEnrollmentLink(token) {
  return unwrap(await http.get(`/commerce/enrollment-links/${encodeURIComponent(token)}`));
}

export async function startEnrollmentCheckout(token, payload) {
  return unwrap(await http.post(`/commerce/enrollment-links/${encodeURIComponent(token)}/checkout`, payload));
}
